// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"display-inlineBlock-1fghviS9mh","block":"display-block-2qLrVSxRL2"};